<template>
  <div class="margin-70">
    <dv-border-box-12 class="operaBox flex flex-direction justify-center padding-sm margin-top-sm">
      <div
        class="operation flex align-center justify-center"
        v-for="(item,index) in overviewList"
        :key="index"
      >
        <div class="margin-right-sm">
          <img class="operateIcon" :src="item.img" />
          <img
            class="right-icon margin-left-sm"
            src="@/assets/images/site/tri.png"
          >
        </div>
        <div class="flex flex-direction text-box">
          <p class="text-xss">{{item.text}}</p>
          <p class="text-sm DS-font margin-top-sm">{{item.number}}</p>
        </div>
      </div>
    </dv-border-box-12>
  </div>
</template>

<script>
// 综合态势--动态渲染图片
import overview1 from "@/assets/images/index/overview3.png";
import overview2 from "@/assets/images/site/statinTimepng.png";
import overview3 from "@/assets/images/site/station-day.png";
import overview4 from "@/assets/images/index/overview2.png";

import { siteLeft } from "@/api/singleSite/left";
import {formatTime} from '@/utils/index'

export default {
  data() {
    return {
      options: {},
      overviewList: [
        {
          text: "充电机生产商",
          number: "",
          img: overview1,
        },
        {
          text: "累计耗电量",
          number: "",
          img: overview4,
        },
        {
          text: "保养周期",
          number: "",
          img: overview3,
        },
        {
          text: "生产日期",
          number: "",
          img: overview2,
        }
      ],
    };
  },
  components: {},
  props: {
    batteryInfo: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    batteryInfo:{
      handler(newValue,oldValue){
        if(newValue){
            let info = newValue;
            this.overviewList= [
          {
            text: "充电机生产商",
            number: info.chargerManufacturer,
            img: overview1,
          },
          {
            text: "累计耗电量",
            number: info.electMeter,
            img: overview4,
          },
          {
            text: "保养周期",
            number: info.maintenancePeriod,
            img: overview3,
          },
          {
            text: "生产日期",
            number:info.productionDate,
            img: overview2,
          }
            ]
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {

    
  },
  methods: {
    
  },
};
</script>
<style lang="scss" scoped>
.margin-70 {
  margin: 70px;
  margin-bottom: 0;
}
.operaBox {
  width: 370px;
}
.operation {
  height: 144px;
}
.operateIcon{
  width:82px;
}
.operation-icon {
  width: 82px;
  height: 72px;
}
.right-icon {
  width: 14px;
  height: 16px;
}
.text-box {
  width: 140px;
}
.DS-font {
  line-height: 24px;
  font-family: "DS-Digital-Bold";
}
</style>